import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

export const getRingRoutesForPoc = async () => {
  try {
    const response = await apiClient.get(`/ring/getAllRoutes`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRingOneAdditionlForPoc = async (id) => {
  try {
    const response = await apiClient.get(`/ring/getOneRingRouteAdditional/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};

export const getRingOneAdditionlCount = async (id) => {
  if (!id) {
    return;
  }
  try {
    const response = await apiClient.get(`/ring/countAdditional/${id}`);
    return response.data;
  } catch (error) {
    handleApiError(error);
  }
};
